import { apiFetch } from './utils/api';
// const mockedOrganization = require('./mocks/v1/wealth-plan/organization.json');

export const organization = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v1/wealth-plan/organizations';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
